<template>
  <!-- <div
    v-if="authStore.isAuthenticated && authStore.user.isDefaultPassword"
    class="pa-0"
  >
    <v-row justify="start" class="mb-6">
      <v-col cols="12">
        <div class="text-start">
          <v-card
            title="กรุณาเปลี่ยนรหัสผ่านก่อนใช้งาน!"
            class="mx-auto mt-5 pa-4 pa-sm-6 text-center"
            max-width="1000"
          >
            <v-card-actions>
              <v-btn
                variant="elevated"
                color="pink"
                @click="
                  (authStore.editAccount = true), (authStore.isEditing = true)
                "
              >
                เปลี่ยนรหัสผ่าน
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div> -->
  <div v-if="authStore.isAuthenticated" class="pa-0">
    <v-container fluid>
      <!-- <v-row justify="start" class="mb-6">
        <v-col cols="12">
          <div class="text-start">
            <h1 class="text-h5 text-sm-h4 font-weight-bold mb-2">
              ยินดีต้อนรับ, {{ authStore.user.displayName }}!
            </h1>
            <p class="text-subtitle-1 text-medium-emphasis">
              ข้อมูลส่วนตัวและผลการเรียนของคุณ
            </p>
          </div>
        </v-col>
      </v-row> -->

      <!-- <v-row justify="start">
        <v-col cols="12" md="6">
          <v-card elevation="10">
            <v-card-title class="bg-primary white--text d-flex align-center">
              <v-icon class="mr-2" color="white">mdi-account-circle</v-icon>
              ข้อมูลส่วนตัว
            </v-card-title>

            <v-card-text class="pa-4 pa-sm-6">
              <v-list lines="two" class="pa-0">
                <v-list-item>
                  <template v-slot:prepend>
                    <v-icon color="primary">mdi-account</v-icon>
                  </template>
                  <v-list-item-title class="font-weight-medium">
                    ชื่อ-นามสกุล
                  </v-list-item-title>

                  <v-list-item-subtitle
                    class="py-2 text-subtitle-1 font-weight-bold text-high-emphasis"
                  >
                    {{ authStore.user.displayName }}
                  </v-list-item-subtitle>
                </v-list-item>

                <v-divider class="my-2"></v-divider>

                <v-list-item>
                  <template v-slot:prepend>
                    <v-icon color="primary">mdi-email</v-icon>
                  </template>
                  <v-list-item-title class="font-weight-medium">
                    อีเมล
                  </v-list-item-title>

                  <v-list-item-subtitle
                    class="text-subtitle-1 font-weight-bold text-high-emphasis"
                  >
                    {{ authStore.user.email }}
                  </v-list-item-subtitle>
                </v-list-item>

                <v-divider class="my-2"></v-divider>

                <v-list-item>
                  <template v-slot:prepend>
                    <v-icon color="primary">mdi-school</v-icon>
                  </template>
                  <v-list-item-title class="font-weight-medium">
                    รหัสนักศึกษา
                  </v-list-item-title>

                  <v-list-item-subtitle
                    class="text-subtitle-1 font-weight-bold text-high-emphasis"
                  >
                    {{ authStore.user.studentNum }}
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->
    </v-container>
  </div>
</template>
<script setup>
import { ref, computed, watch, onMounted } from "vue"; // No direct onMounted needed due to `watch` with `immediate: true`
import { useAuthStore } from "@/stores/auth";
const emit = defineEmits(["buttonClicked"]);
const authStore = useAuthStore();
const getStatusColor = (status) => {
  // Customize based on your actual status values
  if (status === "passed") {
    return "success";
  } else if (status === "fail") {
    return "warning";
  } else {
    return "error";
  }
};
const getStatusIcon = (status) => {
  if (status === "ผ่าน" || status === "Pass" || status === "Completed") {
    return "mdi-check-circle";
  } else if (status === "กำลังดำเนินการ" || status === "In Progress") {
    return "mdi-clock";
  } else {
    return "mdi-close-circle";
  }
};

const getScoreColor = (score) => {
  if (score >= 80) return "success";
  if (score >= 60) return "warning";
  return "error";
};
</script>
